/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — vanilla replacement for jQuery.getScript;
 *              dynamically injects a <script> tag and resolves on load
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      -
 *   siblings:  sibling `./utility/*` themed modules, re-exported via
 *              ../utility.js barrel
 *   tests:     load-script-test.js (unit)
 *
 * @module beebee-base/lib/utility/load-script
 * @description Vanilla replacement for jQuery.getScript — dynamically injects a
 * <script> tag and resolves when it has loaded (and executed in global scope).
 */

/**
 * Load and execute an external script.
 * @param {string} url - Script URL
 * @returns {Promise<void>} Resolves on load, rejects on error
 */
function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`[loadScript] Failed to load: ${url}`));
    document.head.appendChild(script);
  });
}

export { loadScript };
//# sourceMappingURL=load-script.js.map
